import React from "react"
import Fade from "react-reveal/Fade"

const CareersRoles = () => {
  return (
    <div className="max-w-7xl mx-auto flex flex-col items-center text-white mt-20 font-poppins">
      <h2 className="text-sm font-bold opacity-50">are you wanting the best?</h2>
      <h1 className="text-6xl font-bold mt-3">Experience, Track Records, and Testimonials.</h1>
      <Fade bottom cascade>
        <div className="grid grid-cols-2 gap-6 mt-10">
          <a
            href="#"
            className="m-5 p-5 bg-lightblack rounded-xl border cursor-pointer hover:border-purple text-left"
          >
            <h2 className="text-3xl font-bold">The Shooter</h2>
            <p className="mt-10 opacity-50">
              deep breath
            </p>
          </a>
          <a
            href="#"
            className="m-5 p-5 bg-lightblack rounded-xl border cursor-pointer hover:border-purple text-left"
          >
            <h2 className="text-3xl font-bold">The Spotter</h2>
            <p className="mt-10 opacity-50">
              green light
            </p>
          </a>
        </div>
      </Fade>
    </div>
  )
}

export default CareersRoles
